import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import EmpowerYourMovement from "./sections/EmpowerYourMovement";
import TheKiraMethod from "./sections/TheKiraMethod";
import ProvenProgress from "./sections/ProvenProgress";
import MeetYourCoach from "./sections/MeetYourCoach";
import TrainingOptions from "./sections/TrainingOptions";
import ReadyToTransform from "./sections/ReadyToTransform";
import FooterEssentials from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <EmpowerYourMovement />
      <TheKiraMethod />
      <ProvenProgress />
      <MeetYourCoach />
      <TrainingOptions />
      <ReadyToTransform />
      <FooterEssentials />
    </div>;
}